import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "info-icon",
  role: "img",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.33334 5.50181C7.33164 5.13099 7.6325 4.83333 7.99934 4.83333C8.36685 4.83333 8.66667 5.13056 8.66667 5.5C8.66667 5.86814 8.36815 6.16667 8.00001 6.16667C7.63247 6.16667 7.33432 5.86912 7.33334 5.50181Z" }, null, -1),
    _createElementVNode("path", { d: "M8.5 8C8.5 7.72386 8.27614 7.5 8 7.5C7.72386 7.5 7.5 7.72386 7.5 8V11.3333C7.5 11.6095 7.72386 11.8333 8 11.8333C8.27614 11.8333 8.5 11.6095 8.5 11.3333V8Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.5 8C1.5 4.40986 4.40986 1.5 8 1.5C11.5901 1.5 14.5 4.40986 14.5 8C14.5 11.5901 11.5901 14.5 8 14.5C4.40986 14.5 1.5 11.5901 1.5 8ZM8 2.5C4.96214 2.5 2.5 4.96214 2.5 8C2.5 11.0379 4.96214 13.5 8 13.5C11.0379 13.5 13.5 11.0379 13.5 8C13.5 4.96214 11.0379 2.5 8 2.5Z"
    }, null, -1)
  ])))
}
export default { render: render }